import { useEffect, useState } from 'react';

// One-shot loader with manual reload. Keeps last-good data; surfaces a benign error message.
export function useLoad<T>(
  loader: () => Promise<T>,
  deps: unknown[] = [],
): { data: T | null; error: string | null; reload: () => void } {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let on = true;
    loader()
      .then((d) => on && setData(d))
      .catch((e) => on && setError(e instanceof Error ? e.message : 'Failed to load'));
    return () => {
      on = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, tick]);

  return { data, error, reload: () => setTick((t) => t + 1) };
}
